module.exports = __webpack_public_path__ + "static/media/refinance.a00cc04c.svg";